import AbstractPageBaseController from '../../../core/abstracts/controllers/page-controller';

export default class ContactsListPageController extends AbstractPageBaseController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.stateParams = this.injector.get('$stateParams');
        this.usersStore = this.injector.get('Users');
        this.store = this.stateParams.store || this.injector.get('Contacts').reset().dispatch('loadState');
    }

    $onInit() {
        this.store.dispatch('loadWorkflows', 'addressbook::list');
        this.store.commit('setEmptyListActions', [
            'quick-create-contact',
            'import-contacts'
        ]);
        this.store.commit('setVm', this);
        this.store.resetGetters();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/list.js